// extracted by mini-css-extract-plugin
module.exports = {"baseMultiSelect":"BaseMultiSelect_baseMultiSelect__LvDF6"};